import { makeStyles } from '@material-ui/styles';

const drawerWidth = 240;

export default makeStyles((theme) => ({
    menuButton: {
        marginLeft: 12,
        marginRight: 36
    },
    hide: {
        display: 'none'
    },
    logotype: {
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        },
        marginLeft: '5px',
        display: 'inline-block',
        float: 'left',
        padding: '2px 0 0 0'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap'
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        'overflow-x': 'hidden',
        background: '#F7F9FA'
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 40,
        [theme.breakpoints.down('sm')]: {
            width: drawerWidth
        }
    },
    toolbar: {
        ...theme.mixins.toolbar,
        minHeight: '75px !important',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3)
    },
    sidebarList: {
        marginTop: theme.spacing(2),
        marginLeft: '13px'
    },
    mobileBackButton: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(),
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    backButtonWrapper: {
        float: 'left',
        padding: '0 0 0 10px'
    },
    selectWrapper: {
        margin: '25px 12px 0px',
        width: '100%',
        paddingRight: '25px'
    },
    selectFromControl: {
        width: '100%',
        paddingRight: '10px',
        backgroundColor: `${theme.palette.primary.main} !important`,
        borderRadius: '5px',
        fontSize: `${theme.palette.textSizeMedium} !important`,
        '& .MuiSelect-select': {
            paddingTop: '22px !important',
            paddingBottom: '7px !important'
        }
    },
    selectLabel: {
        color: '#FFF !important'
    },
    selectIcon: {
        fill: '#FFF !important'
    },
    createIncidentButton: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white !important'
        },
        margin: '0 15px 0 15px',
        position: 'absolute',
        bottom: '80px',
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        width: '87%',
        fontSize: theme.palette.textSizeLarge
    }
}));
